import useMutationApi from 'src/api/useMutationApi';

const useTestEmailApi = (onSuccess?: () => void, onError?: () => void) => {
  return useMutationApi<unknown>({
    endpoint: `oauth/azure/test-email-api`,
    method: 'POST',
    options: {
      onSuccess: (res) => {
        console.log({ res });
      },
      onError,
    },
  });
};

export default useTestEmailApi;
